import t from 'react-translate';
import { useAppDispatch } from 'redux/store';
import {
  openConfirmationDialog,
  closeConfirmationDialog,
} from 'redux/actions/confirmation-dialogs';

import { config } from '@config/pendo.config.json';

import { css } from '@emotion/react';
import { semiBoldFontWeight } from 'styles/global_defaults/fonts';

import { useMentorRequestContext } from '../mentor-request-context';
import { Button } from 'react-bootstrap';

const styles = css`
  font-weight: ${semiBoldFontWeight} !important;
`;

const MentorRequestWithdrawRequestButton = () => {
  const dispatch = useAppDispatch();
  const { withdrawRequest, participant } = useMentorRequestContext();
  const translationBase =
    t.MENTORING_PROGRAMS.PARTICIPANT_HOME.MENTOR_REQUEST_MODAL.MENTEE_VIEW
      .WITHDRAW_CONFIRMATION_DIALOG;

  const handleClick = () => {
    dispatch(
      openConfirmationDialog({
        title: translationBase.TITLE(),
        bodyText: translationBase.BODY(participant.user.firstName),
        confirmText: translationBase.WITHDRAW(),
        cancelText: translationBase.CANCEL(),
        onConfirm: () => {
          dispatch(closeConfirmationDialog());
          withdrawRequest();
        },
      })
    );
  };

  const dataQATag =
    config.pendo.athena.mentorshipProgram.participantHome.mentorRequest.modal
      .mentee.withdrawRequestButton;

  return (
    <Button
      variant='link'
      className='p-0'
      css={styles}
      onClick={handleClick}
      data-qa={dataQATag}
    >
      {t.MENTORING_PROGRAMS.PARTICIPANT_HOME.MENTOR_REQUEST_MODAL.MENTEE_VIEW.WITHDRAW_REQUEST()}
    </Button>
  );
};

export default MentorRequestWithdrawRequestButton;
